export const getCurrentUrl = () => new URL(window.location.href);
//# sourceMappingURL=getCurrentUrl.js.map